// Components
import { FormElems } from 'components';

// Helper
import { nameValueOptions } from 'utils/helperMethods';

// Actions
import { uploadNetworkBinFileRequest } from '../../containers/ManageBin/redux/manageBin.actions';

// Assets
import DownloadIcon from '../../static/images/downloadIcon.png';

// Libs
import { ERROR_MESSAGES } from '../../utils/constants/toastMessages';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { Field, reduxForm, change } from 'redux-form';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import './binFormatting.scss';

const networkOptions = ['Master', 'Visa', 'Rupay'];
const filePlaceHolder = { name: 'Upload file in required format' };

const BinFormatting = ({ handleSubmit, formData, actions }) => {
    const [selectedFile, setSelectedFile] = useState(filePlaceHolder);

    const handleFormSubmit = values => {
        //console.log(values,"values");
        if(!values.binType){
            toast.info(ERROR_MESSAGES.PLEASE_SELECT_BIN_TYPE);
        }else if(!values.issuerBinFile){
            toast.info(ERROR_MESSAGES.PLEASE_UPLOAD_BIN_FILE);
        }else{
            const formData = new FormData();
            formData.append('issuerBinFile', values.issuerBinFile);
            formData.append('binType', values.binType);
            actions.uploadNetworkBinFileRequest(formData);
        }
    };

    const handleFileChange = (value, event) => {
        event.preventDefault();
        const files = event.target.files[0];
        if (files && /.+(\.(csv|xlsx|xlsm))$/i.test(files.name)) {
            actions.change('bin-formatting-form', 'issuerBinFile', files);
            setSelectedFile(files);
        } else {
            toast.info(ERROR_MESSAGES.ONLY_CSV_XLSM_XLSX_FILE);
        }
    };

    return (
        <div className="bin-formatting-wrapper">
            <div className="bin-header">
                <h3 className="page-title">Manage Bin Format</h3>
            </div>
            <form
                className="bin-formatting-form"
                onSubmit={handleSubmit(handleFormSubmit)}
            >
                <div className="form-section">
                    <div className="form-field">
                        <p className="label">Select Network/Bank Type*</p>
                        <Field
                            name="binType"
                            placeholder="Bin Type"
                            id="file-type"
                            data={nameValueOptions(networkOptions) || []}
                            labelField="name"
                            valueField="value"
                            component={FormElems.Select}
                            label="Select Bin Type"
                        />
                    </div>
                </div>
                <div className="form-section">
                    <div className="form-field">
                        <label htmlFor="UploadBinFile" className="file-label">
                            <img
                                src={DownloadIcon}
                                alt="Download"
                                className="download-icon"
                            />
                            <div className="action-text">
                                <p>
                                    {formData?.values?.binType
                                        ? `Upload Bin File for ${formData.values.binType}`
                                        : 'Upload Bin File'}
                                </p>
                                <label>{selectedFile.name || ''}</label>
                            </div>
                        </label>
                        <FormElems.Input
                            name="issuerBinFile"
                            type="file"
                            id="UploadBinFile"
                            wrapperClass="fileInput"
                            defaultValue="fileName"
                            input="true"
                            accept=".csv,.xlsx,.xlsm"
                            handleChange={handleFileChange}
                        />
                    </div>
                </div>
                <div className="form-section">
                    <div className="form-field">
                        <FormElems.Button
                            buttonType="primary"
                            text="Upload File"
                            id="submit-button"
                            type="submit"
                        />
                    </div>
                </div>
            </form>
        </div>
    );
};

BinFormatting.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    change: PropTypes.func,
    handleSubmit: PropTypes.func,
    formData: PropTypes.object,
};

const mapStateToProps = ({ form, auth }) => ({
    auth,
    formData: form['bin-formatting-form'],
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        { uploadNetworkBinFileRequest, change },
        dispatch
    ),
});

export default withRouter(
    compose(
        reduxForm({
            form: 'bin-formatting-form',
            enableReinitialize: true,
            validate: () => { },
        }),
        connect(mapStateToProps, mapDispatchToProps)
    )(BinFormatting)
);
